import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { IFlowStepProps } from '@folx-types/flow-steps';

import ExceptionalConditionsStep, {
	IExceptionalConditionsStepPageContent,
} from './ExceptionalConditionsStep.component';

interface IExceptionalConditionsStepPageProps extends IFlowStepProps {}

const ExceptionalConditionsStepPage: FC<IExceptionalConditionsStepPageProps> = ({
	path,
	stepKey,
}) => {
	const { pageContent } = useStaticQuery<Record<string, string>>(graphql`
		{
			pageContent: butterPage(slug: { eq: "mh-exceptional-conditions" }) {
				page_header
				page_subheader
				suicidal_thoughts_question
				severity_question
				vague_thoughts_answer
				specific_plan_answer
			}
		}
	`);

	const refinedContent: IExceptionalConditionsStepPageContent = keysToCamel(
		pageContent
	) as IExceptionalConditionsStepPageContent;

	return <ExceptionalConditionsStep path={path} stepKey={stepKey} pageContent={refinedContent} />;
};

export default ExceptionalConditionsStepPage;
